/* eslint-disable @typescript-eslint/triple-slash-reference */
// tslint:disable-next-line: no-reference
/// <reference path='../../images.d.ts'/>
import { ReactComponent as GoogleLogo } from '../../assets/svg/google-logo.svg';
export default GoogleLogo;
